module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18JzbfJ/images/e9781439621776_cover.jpg?1688985069299",
      "alt": "This image is the cover for the book Irvington, Images of America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Irvington, Images of America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Like a cherished old family album, this collection of more than two hundred fascinating photographs of Irvington brings to life people, places, and events of a bygone era. Although the Irvington depicted here�from the time of the Civil War to the 1970s�has changed significantly, its memory remains fresh in the minds of past and present residents alike. Culled from the extensive collections of the Irvington Public Library and Irvington Historical Society, this superb assemblage of images will stimulate many memories. Alan A. Siegel takes us on a delightful journey, starting when Irvington was a tiny village known as Camptown, to the twentieth century when Irvington was transformed almost overnight into a busy industrial and residential suburb of Newark. Shown too are the vital contributions made by successive waves of immigrants who flooded into Irvington during the first half of the twentieth century.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alan A. Siegel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Mr. Siegel is the author of three other books about Irvington: Out of Our Past, a history of the township published in 1974; For the Glory of the Union, the story of a Civil War regiment raised in Irvington; and Smile, a photographic history of Olympic Park now in its fifth printing. As we make our way into the uncharted territory of the next millennium, this new work provides us with a beautifully crafted guide to the lessons and events of this area�s rich past.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0